export const figure48 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '800px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#5b9bd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    exporting: {
      enabled: false
    },

xAxis: {
    categories: [
		 "Caraïbes",
		 "Amérique centrale",
		 "Asie centrale",
		 "Afrique de l’Est",
		 "Asie de l’Est",
		 "Europe orientale",
		 "Mélanésie",
		 "Micronésie",
		 "Afrique moyenne",
		 "Afrique du Nord",
		 "Europe septentrionale",
		 "Polynésie",
		 "Amérique du Sud",
		 "Asie du Sud-Est",
		 "Afrique australe",
		 "Asie du Sud",
		 "Europe méridionale",
		 "Afrique de l’Ouest",
		 "Asie de l’Ouest",
		 "Europe occidentale",
    ],
    title: {
        text: null
    }
},
yAxis: {
    min: 0,
    max: 30,
    tickInterval: 5,
    title: {
        text: null,
    },
    labels: {
        overflow: 'justify'
    }
},

plotOptions: {
    bar: {
        dataLabels: {
            enabled: false,
        }
    }
},
legend: {
    enabled: false,
},
series: [{
    name: '',
    data: [ 18.9, 14.7, 9.9, 17.1, 15.3, 4.6, 15.0, 7.5, 20.6, 15.7, 9.9, 13.1, 11.8, 14.7, 21.8, 13.9, 7.1, 24.8, 14.1, 6.5,] ,
}]
}